import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ApiService } from '../../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-excel-list',
  templateUrl: './excel-list.component.html',
  styleUrl: './excel-list.component.css'
})
export class ExcelListComponent {
  constructor(private fb: FormBuilder, private apiService: ApiService, private toastrService: ToastrService, private router: Router,) { }


excelData: any[] = [];
totalRecords: number = 0;


pagination = {
  pageNumber: 1,
  pageSize: 10,
  searchTerm: '',
  sortColumn: 'CreatedDate',
  sortDirection: 'DESC'
};

paginationexcel = {
  pageNumber: 1,
  pageSize: 999999, // Large size for full export
  searchTerm: '',
  sortColumn: 'CreatedDate',
  sortDirection: 'DESC'
};
  

  
  ngOnInit() {
  this.loadData();
}
loadData() {
  this.apiService
    .getRequest(API_ENDPOINTS.MSSIDC.GET_SPORT_ATTENDANCE_FILES, this.pagination)
    .subscribe({
      next: (res: any) => {
        if (res.status) {

          // ✅ bind data
          this.excelData = res.data || [];

          // ✅ bind total records
          this.totalRecords = res.totalRecords || 0;

          console.log('Bind Data:', this.excelData);

        } else {
          this.excelData = [];
        }
      },
      error: (err) => {
        console.error(err);
        this.excelData = [];
      }
    });
}
onPageChange(event: any) {
  this.pagination.pageNumber = event.pageIndex + 1;
  this.pagination.pageSize = event.pageSize;
  this.loadData();
}

downloadFile(row: any) {
  const fileUrl = `${row.FilePath}`;
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = row.originalFileName;
  link.click();
}

onSpotRegistration() {


  this.router.navigate(['/Spot-Attendance']);


}

sort(column: string) {
  if (this.pagination.sortColumn === column) {
    this.pagination.sortDirection =
      this.pagination.sortDirection === 'ASC' ? 'DESC' : 'ASC';
  } else {
    this.pagination.sortColumn = column;
    this.pagination.sortDirection = 'ASC';
  }

  this.loadData();
}
searchTimeout: any;

onSearchChange(value: string) {
  clearTimeout(this.searchTimeout);

  this.searchTimeout = setTimeout(() => {
    this.pagination.searchTerm = value;
    this.pagination.pageNumber = 1;
    this.loadData();
  }, 500);
}
resetFilters() {
  this.pagination = {
    pageNumber: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: 'CreatedDate',
    sortDirection: 'DESC'
  };

  this.loadData();
}

isPopupOpen = false;
onspotvalidData:any[]=[]
type:any
EventId:any


MSMEPopupvalid(row:any,type:any){ 
  console.log('chk',row);
  this.EventId = row.EventId;
   console.log('chk',this.EventId);
this.type  = 'valid' 
  var obj = {
    FileId : row.Id
  }

    this.apiService
    .getRequest(API_ENDPOINTS.MSSIDC.GET_SPORT_ATTENDANCE_FILES_velidMSMEList,obj)
    .subscribe({
      next: (res: any) => {
        if (res.status) {

          EventId: row.EventId,
console.log('API Response:', res);
          // ✅ bind data
          this.onspotvalidData = res.data || [];

          // // ✅ bind total records
          // this.totalRecords = res.totalRecords || 0;

          console.log('Bind Data:', this.onspotvalidData);

        } else {
          this.onspotvalidData = [];
        }
      },
      error: (err) => {
        console.error(err);
        this.onspotvalidData = [];
      }
    });
  this.isPopupOpen = true;



}



MSMEPopupNotValid(row:any,type:any){
   console.log(row.Id);
  this.EventId = row.EventId;
   console.log('chk',this.EventId);
this.type  = 'notvalid'

  var obj = {
    FileId : row.Id
  }

    this.apiService
    .getRequest(API_ENDPOINTS.MSSIDC.GET_SPORT_ATTENDANCE_FILES_NOtvelidMSMEList,obj)
    .subscribe({
      next: (res: any) => {
        if (res.status) {

          // ✅ bind data
          this.onspotvalidData = res.data || [];

          // // ✅ bind total records
          // this.totalRecords = res.totalRecords || 0;

          console.log('Bind Data:', this.onspotvalidData);

        } else {
          this.onspotvalidData = [];
        }
      },
      error: (err) => {
        console.error(err);
        this.onspotvalidData = [];
      }
    });
  this.isPopupOpen = true;
}

closePopup() {
  this.isPopupOpen = false;
}

exportToExcel() {

  this.apiService
    .getRequest(
      API_ENDPOINTS.MSSIDC.GET_SPORT_ATTENDANCE_FILES,
      this.paginationexcel
    )
    .subscribe({

      next: (res: any) => {

        if (res.status && res.data?.length > 0) {

          this.excelData = res.data;
          console.log('Data for Excel Export:', this.excelData);

          // ✅ Prepare Excel Data
          const excelExportData = this.excelData.map(
            (row: any, i: number) => ({

              'Sr No':
                (this.pagination.pageNumber - 1) *
                this.pagination.pageSize + i + 1,

              'IA User Name': row.IAName,

              'Event Id': row.EventId,

              'Event Name': row.EventName,

              'Intervention': row.Intervention,

              'Component': row.Component,

              'Event Date': row.EventDate,

              'Original File Name': row.OriginalFileName,

              'Valid MSME Count': row.ValidMsmeCount,

              'Not Valid MSME Count': row.NotValidMsmeCount,

              'Old Count':
                (row.OnSpotRegistrationCount || 0) -
                (row.ValidMsmeCount || 0),

              'Revise Count':
                (row.OnSpotRegistrationCount || 0)

            })
          );

          // ✅ Convert JSON to worksheet
          const worksheet: XLSX.WorkSheet =
            XLSX.utils.json_to_sheet(excelExportData);

          // ✅ Create workbook
          const workbook: XLSX.WorkBook = {
            Sheets: {
              'Attendance Report': worksheet
            },
            SheetNames: ['Attendance Report']
          };

          // ✅ Export file
          XLSX.writeFile(
            workbook,
            `Attendance_Report_${new Date().getTime()}.xlsx`
          );

          this.toastrService.success(
            'Excel exported successfully'
          );

        } else {

          this.toastrService.warning(
            'No data available'
          );

        }
      },

      error: (err) => {

        console.error(err);

        this.toastrService.error(
          'Export failed'
        );

      }

    });
}
}
